import { render, staticRenderFns } from "./ModalBandeirasCheckinpay.vue?vue&type=template&id=f06b164a&scoped=true&"
import script from "./ModalBandeirasCheckinpay.vue?vue&type=script&lang=js&"
export * from "./ModalBandeirasCheckinpay.vue?vue&type=script&lang=js&"
import style0 from "./ModalBandeirasCheckinpay.vue?vue&type=style&index=0&id=f06b164a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06b164a",
  null
  
)

export default component.exports